import { Box, CircularProgress } from '@mui/material'
import { useNotification } from 'hooks'
import { Document, Page } from 'react-pdf'

const PDFPrintDocument = ({ pdfFile, componentRef }) => {
  const { showNotification } = useNotification()

  const onDocumentLoadSuccess = ({ numPages }) => {
    //TODO what should we do here? does the document have multiple pages?
  }

  const onDocumentLoadError = error => {
    if (error?.message == 'Worker was destroyed') {
      return
    }

    showNotification({
      message: `A aparut o eroare la descarcarea fisierului. ${error.message}`,
      type: 'error'
    })
  }

  return (
    <div style={{ display: 'none' }}>
      <Box ref={componentRef}>
        <Document
          file={pdfFile}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          loading={<CircularProgress color="primary" style={{ margin: '40px auto' }} />}
        >
          <Page
            pageNumber={1}
            scale={1.5}
            loading={<CircularProgress color="primary" style={{ margin: '40px auto' }} />}
          />
        </Document>
      </Box>
    </div>
  )
}

export default PDFPrintDocument
